export enum AdditionalStatsContentContainerBlock {
  Root = 'AdditionalStatsContentContainer',
}

export enum AdditionalStatsContentContainerElement {
  Title = 'title',
  Content = 'content',
}
